/*!
 * @monogrid/vue-boost v8.0.1 Copyright (C) MONOGRID S.R.L. - All Rights Reserved - Unauthorized copying of this file, via any medium is strictly prohibited
 */
import { useLayerStack as o } from "@monogrid/vue-boost/core";
import { useFocusTrap as r } from "@vueuse/integrations/useFocusTrap";
function u(a, c) {
  const t = r(a, c), { active: e } = o(a, {
    activate: t.activate,
    deactivate: t.deactivate
  });
  return { active: e, focusTrap: t };
}
export {
  u as useStackedFocusTrap
};
